import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchLanguages, selectLanguages } from '../../redux/slices/dataSlice';

export default function LanguageSelector({ onLanguageChange, isLawyer = false }) {
  const dispatch = useDispatch();
  const languages = useSelector(selectLanguages);
  const [selectedLanguages, setSelectedLanguages] = useState([]);

  useEffect(() => {
    dispatch(fetchLanguages());
  }, [dispatch]);

  const handleLanguageToggle = languageId => {
    const newSelectedLanguages = selectedLanguages.includes(languageId)
      ? selectedLanguages.filter(id => id !== languageId)
      : [...selectedLanguages, languageId];

    setSelectedLanguages(newSelectedLanguages);

    if (onLanguageChange) {
      onLanguageChange(newSelectedLanguages);
    }
  };

  if (languages.isLoading || !languages.data) {
    return (
      <div className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-gray-100 text-gray-500">
        Cargando idiomas...
      </div>
    );
  }

  return (
    <div className="space-y-2">
      <label className={`text-xs mb-1 ${isLawyer ? 'text-gray-300' : 'text-gray-500'}`}>
        Idiomas que maneja
      </label>
      <div className="grid grid-cols-2 gap-2">
        {(languages.data || []).map(language => (
          <label
            key={language.id_language}
            className={`flex items-center space-x-2 p-2 rounded-lg border cursor-pointer transition-colors ${
              selectedLanguages.includes(language.id_language)
                ? isLawyer
                  ? 'bg-blue-600 border-blue-500 text-white'
                  : 'bg-blue-100 border-blue-500 text-blue-900'
                : isLawyer
                  ? 'bg-transparent border-gray-400 text-white hover:border-gray-300'
                  : 'bg-white border-gray-300 text-gray-900 hover:border-gray-400'
            }`}
          >
            <input
              type="checkbox"
              checked={selectedLanguages.includes(language.id_language)}
              onChange={() => handleLanguageToggle(language.id_language)}
              className="sr-only"
            />
            <span className="text-sm">{language.language}</span>
          </label>
        ))}
      </div>
    </div>
  );
}
